import React, { ReactNode } from "react"
import { classNames } from "../../app/Components"

type TableData = string | number | boolean | null | undefined;

interface TableRowData {
  actions?: ReactNode[];
  cellClassNames?: (string | undefined)[];
  content?: ReactNode;
  data: TableData[];
  onClick?: () => void;
}

interface TableRowProps {
  className?: string;
  data: TableRowData;
}

function TableRow({ className, data }: TableRowProps) {
  return (
    <>
      <div className={classNames(["TableRow", className, data.onClick && "click"])} onClick={data.onClick}>
        {data.data.map((cell, index) => (
          <div className={classNames(["TableCell", data.cellClassNames?.[index]])} key={"cell" + index}>
            {cell !== null && cell !== undefined ? cell.toString() : ""}
          </div>
        ))}
        {data.actions && data.actions.map((action, index) => (
          <div className="TableCell TableAction" key={"action" + index}>
            {action}
          </div>
        ))}
      </div>
      {data.content && <div className="TableRowContent">{data.content}</div>}
    </>
  );
}

interface TableProps {
  columnWidths?: string[];
  data: TableRowData[];
  header?: TableRowData | TableData[];
}

export function Table({ columnWidths, data, header }: TableProps) {
  const style = columnWidths ? {
    "--col-widths": columnWidths.join(" "),
  } as React.CSSProperties : undefined;

  return (
    <div className="Table" style={style}>
      {header && <TableRow className="TableHeader" data={Array.isArray(header) ? { data: header } : header} key="header" />}
      {data.map((row, index) => {
        return <TableRow data={row} key={index} />;
      })}
    </div>
  );
}
